import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Transition } from '@oneToOne/shared/styles'

export const IdleStateTextBox = styled.div<{
  isVisible: boolean
}>`
  ${Transition}
  display: inline-flex;
  cursor: pointer;
  padding: 8px;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 10px;
  flex-wrap: wrap;
  border-radius: 4px;
  background: #fff;
  color: var(--gray-9);
  margin-bottom: 8px;
  max-width: 300px;
  box-shadow: var(--box-shadow);
  ${({ isVisible }) =>
    isVisible
      ? css`
          opacity: 1;
          pointer-events: auto;
          transform: translateY(0);
        `
      : css`
          opacity: 0;
          pointer-events: none;
          transform: translateY(100%);
        `}
`
